import { AxiosError } from "axios";
import environment from "../../../../../environments/environment";
import { axiosInterceptor } from "../../../services/authInterceptor";
import { notifyUser } from "../../../Utils/notifyUser";

const INVOICE_DETAIS_BY_INVOICEID_URL = environment.getVendorInvoiceByInvoiceId;

export async function saveTaskApproverReassign(approverList: any, taskId: number) {


  try {
    const response = await axiosInterceptor.post(`${environment.saveTaskApproveReassignURL}${taskId}`, approverList);
    return response;
  } catch (error: any) {
    ;
    const errorMessage =
      error?.response?.data?.message || error?.message || "Unexpected error";
    notifyUser(errorMessage, 'error', "Task Approver");
    return error;
  }
}

export async function getTaskApprovalByTaskId(taskId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.getTaskApprovalByTaskIdMailURL}${taskId}?isActive=Y&clientId=${clientId}`, {
      headers: { 'Content-Type': 'application/json' }
    });
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function sendTaskReminderApprovalMail(invoiceId: number, taskId: number) {

  try {
    const response = await axiosInterceptor.put(`${environment.sendTaskReminderApprovalMailURL}${invoiceId}/task/${taskId}?action=taskReminder`);
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function saveInvoiceStateHistory(invoiceId: number, comments: string) {

  let invoiceStateHistoryVO = {
    invoiceId: invoiceId,
    state: "comments",
    description: comments
  }
  try {
    const response = await axiosInterceptor.post(`${environment.saveInvoiceStateHistoryURL}`, invoiceStateHistoryVO);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getCancelInvoice(invoiceId: number, comments: string) {
  try {
    const response = await axiosInterceptor.post(`${environment.cancelVendorInvoiceURL}${invoiceId}/cancel?cancellationReason=${comments}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getInvoicePaymentAccounts(participantId: number, projectNumber: string, isActive: string, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.getPaymentAccountsByPIdURL}${participantId}?projectNumber=${projectNumber}&isActive=${isActive}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}
export async function getTaskSummayDetailsByInvoiceId(invoiceId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.getTaskDetailsByInvoiceIdURL}${invoiceId}?isActive=Y&clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getVendorInvoiceDetailsByInvoiceId(invoiceId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${INVOICE_DETAIS_BY_INVOICEID_URL}${invoiceId}?clientId=${clientId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getVendorListPId(searchParam: string, participantId: number, clientId: number) {
  try {
    const resVendorListPId = await axiosInterceptor.get(`${environment.getVendorList}${searchParam}?participantId=${participantId}&clientId=${clientId}`);
    return resVendorListPId;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getInvoiceNumberByVendorName(vendorName: string, clientId: number) {
  try {
    const resInvoiceNumberByVendorName = await axiosInterceptor.get(`${environment.getInvNumberByVendorName}${vendorName}?clientId=${clientId}`);
    return resInvoiceNumberByVendorName;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function postedToNetSuite(invocieId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.post(`${environment.postedToNetSuite}${invocieId}/netsuite?clientId=${clientId}`);
    return response;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postedToCompleteInvoice(invocieId: number, clientId: number) {
  try {
    const response = await axiosInterceptor.put(`${environment.postedToCompleteInvoice}${invocieId}/complete?clientId=${clientId}`);

    return response;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}